import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'
import Routes from '../../constants/routes'
import QuadrantLoader from '../loaders/quadrant-loader/QuadrantLoader'

const UnauthorizedRoute = ({ children }) => {
    const user = useSelector(state => state.auth.user)
    const isWaitingForGetCurrentUser = useSelector(state => state.auth.isWaitingForGetCurrentUser)
    const location = useLocation()

    if (isWaitingForGetCurrentUser) {
        return <QuadrantLoader />
    } else if (!user) {
        return children
    } else {
        return <Navigate to={Routes.HOME} state={{ from: location }} replace />
    }
}

export default UnauthorizedRoute
